<template>
  <BottomModal
    :visible="Boolean(status)"
    :fullHeight="false"
    @close="$emit('close')"
  >
    <div v-if="status" class="transfer-modal__content" :class="status === 'success' ? 'transfer-modal__content--success' : 'transfer-modal__content--error'">
      <div class="transfer-modal__icon-wrap" :class="status === 'success' ? 'transfer-modal__icon-wrap--success' : 'transfer-modal__icon-wrap--error'">
        <svg
          v-if="status === 'success'"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2.5"
          stroke-linecap="round"
          stroke-linejoin="round"
          aria-hidden="true"
        >
          <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
          <polyline points="22 4 12 14.01 9 11.01" />
        </svg>
        <svg
          v-else
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2.5"
          stroke-linecap="round"
          stroke-linejoin="round"
          aria-hidden="true"
        >
          <circle cx="12" cy="12" r="10" />
          <line x1="12" y1="8" x2="12" y2="12" />
          <line x1="12" y1="16" x2="12.01" y2="16" />
        </svg>
      </div>

      <h2 class="transfer-modal__title">
        {{ status === 'success' ? 'Transferência enviada!' : 'Não foi possível transferir' }}
      </h2>

      <p v-if="status === 'success' && netAmount !== undefined" class="transfer-modal__amount">
        {{ formatCurrency(netAmount) }}
      </p>

      <p class="transfer-modal__description">
        {{
          status === 'success'
            ? 'O valor chegará em breve na sua chave Pix cadastrada. O prazo pode variar conforme o banco destinatário.'
            : (errorMessage || 'Ocorreu um erro ao processar a transferência. Tente novamente mais tarde.')
        }}
      </p>

      <button class="transfer-modal__btn transfer-modal__btn--primary" @click="$emit('close')">
        {{ status === 'success' ? 'Entendido' : 'Fechar' }}
      </button>
    </div>
  </BottomModal>
</template>

<script setup>
import BottomModal from '@/components/BottomModal.vue';
import { formatBRL as formatCurrency } from '@/utils/currencyFormatter';

defineProps({
  status: {
    type: String,
    default: null,
    validator: (value) => value === null || value === 'success' || value === 'error',
  },
  netAmount: {
    type: Number,
    default: undefined,
  },
  errorMessage: {
    type: String,
    default: '',
  },
});

defineEmits(['close']);
</script>

<style scoped>
.transfer-modal__content {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 12px;
  max-width: 400px;
  margin: 0 auto;
}

.transfer-modal__icon-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 72px;
  height: 72px;
  border-radius: 50%;
  margin-bottom: 4px;
}

.transfer-modal__icon-wrap svg {
  width: 36px;
  height: 36px;
}

.transfer-modal__icon-wrap--success {
  background-color: #dcfce7;
  color: #16a34a;
}

.transfer-modal__icon-wrap--error {
  background-color: #fee2e2;
  color: #dc2626;
}

.transfer-modal__title {
  font-size: 20px;
  font-weight: 700;
  color: #111827;
  margin: 0;
  letter-spacing: -0.02em;
}

.transfer-modal__amount {
  font-size: 32px;
  font-weight: 800;
  color: #16a34a;
  margin: 0;
  letter-spacing: -0.03em;
}

.transfer-modal__description {
  font-size: 14px;
  color: #6b7280;
  line-height: 1.6;
  margin: 0;
  max-width: 320px;
}

.transfer-modal__btn {
  width: 100%;
  max-width: 320px;
  padding: 14px 24px;
  border-radius: 14px;
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;
  border: none;
  margin-top: 8px;
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}

.transfer-modal__btn--primary {
  background-color: #ec4899;
  color: #ffffff;
  box-shadow: 0 4px 12px rgba(236, 72, 153, 0.3);
}

.transfer-modal__btn--primary:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 16px rgba(236, 72, 153, 0.35);
}

.transfer-modal__btn--primary:active {
  transform: translateY(0);
}
</style>
